import axios from '../../axios'

// 新增小分限制
export const addSmallscorelimit = (data) => {
    return axios({
        url: '/api/data/wish/small/score/limit',
        method: 'POST',
        data
    })
}

// 修改小分限制
export const editSmallscorelimit = (data) => {
    return axios({
        url: '/api/data/wish/small/score/limit',
        method: 'PUT',
        data
    })
}

// 获取小分限制详情
export const getSmallscorelimit = (data) => {
    return axios({
        url: '/api/data/wish/small/score/limit',
        method: 'GET',
        data
    })
}

// 删除小分限制
export const deleteSmallscorelimit = (data) => {
    return axios({
        url: '/api/data/wish/small/score/limit',
        method: 'DELETE',
        data
    })
}

// 获取小分限制列表
export const getSmallscorelimitList = (data) => {
    return axios({
        url: '/api/data/wish/small/score/limit',
        method: 'GET',
        data
    })
}

// 导入小分限制
export const importSmallscorelimit = (data) => {
    return axios({
        url: '/api/data/wish/small/score/limit/import',
        method: 'POST',
        data
    })
}

// 导出小分限制
export const exportSmallscorelimit = (data) => {
    return axios({
        url: '/api/data/wish/small/score/limit/export',
        method: 'POST',
        data
    })
}

// 批量更新小分限制
export const updateSmallscorelimit = (data) => {
    return axios({
        url: '/api/data/wish/small/score/limit/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除小分限制
export const allDeleteSmallscorelimit = (data) => {
    return axios({
        url: '/api/data/wish/small/score/limit/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/smallscorelimit.js